import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

const DischargeSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>4-2. 퇴원</h3>

      {/* 퇴원시각 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">퇴원시각</label>
          <div className="input_2col">
            <DateTimeInput
              id="Discharge_datetime"
              value={formData.Discharge_datetime || ""}
              onChange={(datetime) =>
                setFormData({
                  ...formData,
                  Discharge_datetime: datetime,
                })
              }
            />
          </div>
        </div>
      </div>

      {/* 퇴원형태 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">퇴원형태</label>
          <div className="input_1col">
            {["생존퇴원", "사망퇴원", "전원", "가망 없는 전원"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="Discharge_Type"
                  value={value}
                  checked={formData.Discharge_Type === value}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      Discharge_Type: e.target.value,
                    })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 퇴원기록지 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">퇴원기록지</label>
          <div className="input_1col">
            <textarea
              id="Discharge_Note"
              value={formData.Discharge_Note || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  Discharge_Note: e.target.value,
                })
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DischargeSection;
